<div class="mapv2-cart">
    <div class="cart-item" *ngFor="let place of selectedPlaces">
      <div class="remove-place">
        <button mat-icon-button (click)="deletePlace(place)">
          <mat-icon class="material-icons-outlined" color="primary">close</mat-icon>
        </button>
      </div>
      <div class="place-ticket">
        <h5>{{ place.selectedTicket!.name }}</h5>
        <p>{{ place.row }} {{ place.number }}</p>
      </div>
      <div class="ticket-price">
        <h5>R$ {{ (place.selectedTicket!.price * place.quantity) | number:'1.2-2' }}</h5>
        <p>R$ {{ (place.selectedTicket!.fee * place.quantity) | number:'1.2-2' }} (Taxa)</p>
      </div>
    </div>
  </div>
  